import { UserBonusCheckpointStatus } from '@/enums/userBonusCheckpointStatus';
import { UserBonusCheckpoints } from '@/models/userBonus/checkpoint';
import { getMoneyOrAmount } from '@starsoft/common/utils';

export function getUserBonusCheckpointLabel(
  item: UserBonusCheckpoints,
  isLoading: boolean,
  isCurrentCheckpoint?: boolean,
) {
  if (isLoading) {
    return <i className="fas fa-circle-notch fa-spin" />;
  }

  switch (item?.status) {
    case UserBonusCheckpointStatus.Created:
      switch (isCurrentCheckpoint) {
        case true:
          return <p>{`${getMoneyOrAmount(item?.progress)}%`}</p>;
        default:
          return <i className="fa-solid fa-lock" />;
      }
    case UserBonusCheckpointStatus.Fulfilled:
      return <i className="fa-solid fa-gift" />;
    case UserBonusCheckpointStatus.Claimed:
      return <i className="fa-solid fa-check" />;
  }
}

export function getUserBonusCheckpointDescription(
  item: UserBonusCheckpoints,
  isCurrentCheckpoint?: boolean,
): string {
  switch (item?.status) {
    case UserBonusCheckpointStatus.Created:
      return 'user_bonus_tracking_progress';
    case UserBonusCheckpointStatus.Fulfilled:
      return 'user_bonus_completed_checkpoint';
    case UserBonusCheckpointStatus.Claimed:
      return 'user_bonus_withdrawal_checkpoint';
  }
}
